import Vue from 'vue'
import { sortByDate } from '@/src/utils/Sort'

export const SET_DOCUMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.documents.data = payload
    state.documents.lastUpdate = new Date()
  }
}
export const ADD_DOCUMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (!Array.isArray(payload)) {
      payload = [payload]
    }
    payload.forEach((item) => {
      const old = state.documents.data.find(
        (document) => document.id === item.id
      )
      if (old) {
        if (item._signatures.length === 0 && old._signatures.length > 0) {
          item._signatures = old._signatures
        }
        Object.keys(item).forEach((key) => {
          old[key] = item[key]
        })
      } else {
        state.documents.data.push(item)
      }
    })
  }
}
// TODO: Atualizar documento? Add signers, add variables, ...
export const SET_DOCUMENTS_LOADING = (state, payload) => {
  state.documents.loading = payload
}

export const SET_DOCUMENTS_BY_CLIENT = (state, payload) => {
  if (!payload || !state || !state.documentsByClient) return
  const idCliente = payload.id_cliente
  if (idCliente === undefined || idCliente === null) return
  const key = String(idCliente)
  const value = Array.isArray(payload.value) ? payload.value : []
  Vue.set(state.documentsByClient.data, key, value)
  Vue.set(state.documentsByClient.lastUpdate, key, new Date())
}

export const SET_DOCUMENTS_BY_CLIENT_LOADING = (state, payload) => {
  if (!payload || !state || !state.documentsByClient) return
  const idCliente = payload.id_cliente
  if (idCliente === undefined || idCliente === null) return
  const key = String(idCliente)
  Vue.set(state.documentsByClient.loading, key, Boolean(payload.loading))
}

export const CLEAR_DOCUMENTS_BY_CLIENT = (state, payload) => {
  if (!payload || !state || !state.documentsByClient) return
  const idCliente = payload.id_cliente
  if (idCliente === undefined || idCliente === null) return
  const key = String(idCliente)
  Vue.delete(state.documentsByClient.data, key)
  Vue.delete(state.documentsByClient.loading, key)
  Vue.delete(state.documentsByClient.lastUpdate, key)
}

export const CLEAR_ALL_DOCUMENTS_BY_CLIENT = (state) => {
  if (!state || !state.documentsByClient) return
  state.documentsByClient.data = {}
  state.documentsByClient.loading = {}
  state.documentsByClient.lastUpdate = {}
}

export const SET_TEMPLATES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.templates.data = payload
    state.templates.lastUpdate = new Date()
  }
}
export const ADD_TEMPLATES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (!Array.isArray(payload)) {
      payload = [payload]
    }
    payload.forEach((item) => {
      const old = state.templates.data.find(
        (template) => template.id === item.id
      )
      if (old) {
        Object.keys(item).forEach((key) => {
          old[key] = item[key]
        })
      } else {
        state.templates.data.push(item)
      }
    })
  }
}
export const SET_TEMPLATES_LOADING = (state, payload) => {
  state.templates.loading = payload
}

export const SET_SIGNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.signers.data = payload
    state.signers.lastUpdate = new Date()

    const filtered = payload.filter((p) => p.ativo)

    if (filtered.length) {
      const sorted = sortByDate({ items: filtered, key: 'data_registro' })

      state.signers.dataFiltered = sorted
    } else {
      state.signers.dataFiltered = []
    }
  }
}
export const ADD_SIGNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (!Array.isArray(payload)) {
      payload = [payload]
    }
    payload.forEach((item) => {
      const old = state.signers.data.find((signer) => signer.id === item.id)
      if (old) {
        Object.keys(item).forEach((key) => {
          old[key] = item[key]
        })
      } else {
        state.signers.data.push(item)
      }
    })
  }
}
export const SET_SIGNERS_LOADING = (state, payload) => {
  state.signers.loading = payload
}

export const SET_VARIABLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.variables.data = payload
    state.variables.lastUpdate = new Date()
  }
}
export const SET_VARIABLES_LOADING = (state, payload) => {
  state.variables.loading = payload
}

export const SET_ROLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.roles.data = payload
    state.roles.lastUpdate = new Date()
  }
}
export const SET_ROLES_LOADING = (state, payload) => {
  state.roles.loading = payload
}

export const SET_SYSTEM_VARIABLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.systemVariables.data = payload
    state.systemVariables.lastUpdate = new Date()
  }
}
export const SET_SYSTEM_VARIABLES_LOADING = (state, payload) => {
  state.systemVariables.loading = payload
}

export const SET_VARIABLES_OPTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.variablesOptions.data = payload
    state.variablesOptions.lastUpdate = new Date()
  }
}
export const SET_VARIABLES_OPTIONS_LOADING = (state, payload) => {
  state.variablesOptions.loading = payload
}
